import {
    IShowAEMBanner
} from '../actions/show-aem-banner';
import { IBillingState } from '../state';

export const showLandingPageBanner =
    (state: IBillingState, action: IShowAEMBanner) => {
        return {
            ...state,
            showBannerAlert: action.data
        }
    };
export const showLandingPageBannerError =
    (state: IBillingState, action: IShowAEMBanner) => {
        return {
            ...state,
            showBannerError: action.data
        }
    };
